import { StoreSearchIcon } from './StoreSearchIcon';

/**
 * author: Colton Wiscombe
 * id C631A061-FDAF-4686-9136-FD37C05FA12B
 * name store-search
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-search.svg
 * tags
 * - Places 
 * - Shopping 
 */
export const ShopLookUpIcon = StoreSearchIcon;
export default ShopLookUpIcon